import {useLocation, useNavigate} from "react-router-dom";
import "../styles/SelectCharacter.scss";
import {BackButton, Background, LanguageSelector} from "../components";
import {getArtistFromPath} from "../utils/artist.utils";
import {path} from "../router/path";
import {CharacterSelector} from "../services/chat";

const SelectCharacter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const artist = getArtistFromPath(location.pathname);

  const handleBack = () => {
    navigate(path.code(artist));
  };

  const handleSelect = () => {
    navigate(path.play(artist));
  };

  const handleExpire = () => {
    navigate(path.waiting(artist));
  };

  return (
    <div className="select-character-container">
      <Background artist={artist} />
      <header className="select-character-header">
        <BackButton artist={artist} onClick={handleBack} />
        <LanguageSelector artist={artist} />
      </header>
      <div className="select-character-body">
        <CharacterSelector
          artist={artist}
          onSelect={handleSelect}
          onExpire={handleExpire}
        />
      </div>
    </div>
  );
};

export default SelectCharacter;
